// frontend/src/features/livestock/shareHeadings.ts
// The heading a shared comparison has when its owner gave it no title
// (docs/plans/2026-10-29-livestock-compare-plan.md, 7.1 and 7.5). The organism
// headings are the backend's COMPARISON_TITLES (services/share_kinds.py) word
// for word, so the link preview, the share sheet and the public page agree.

import type { LivestockType } from '@/types/livestock';

/** A tank shots link's heading. */
export const TANK_COMPARISON_TITLE = 'Tank comparison';

/** An organism link's heading when its type isn't one of the four. */
export const LIVESTOCK_COMPARISON_TITLE = 'Livestock comparison';

export const COMPARISON_TITLES: Readonly<Record<LivestockType, string>> = {
  fish: 'Fish comparison',
  coral: 'Coral comparison',
  invertebrate: 'Invertebrate comparison',
  plant: 'Plant comparison',
};

/** "Coral comparison" for a coral; "Livestock comparison" without a known type. */
export function organismComparisonTitle(type: LivestockType | null | undefined): string {
  return (type && COMPARISON_TITLES[type]) || LIVESTOCK_COMPARISON_TITLE;
}
